var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtpCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48Z",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10C42.8651 10 37.9681 11.0185 33.5 12.8644M10 48C10 35.6578 15.8841 24.6899 25 17.7485",
    stroke: "#52AE30",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 51C84 69.2254 69.2254 84 51 84C32.7746 84 18 69.2254 18 51C18 32.7746 32.7746 18 51 18C69.2254 18 84 32.7746 84 51ZM64.266 39.5228C64.6697 39.146 64.6915 38.5132 64.3147 38.1094C63.9379 37.7057 63.3051 37.6839 62.9013 38.0607L41.7326 57.8182L35.1241 51.2096C34.7336 50.8191 34.1004 50.8191 33.7099 51.2096C33.3194 51.6002 33.3194 52.2333 33.7099 52.6239L41.0016 59.9155C41.3826 60.2966 41.997 60.3072 42.391 59.9395L64.266 39.5228Z",
    fill: "#52AE30",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5837 37.792L40.7087 58.2087L33.417 50.917",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5 16C80.3284 16 81 15.3284 81 14.5C81 13.6716 80.3284 13 79.5 13C78.6716 13 78 13.6716 78 14.5C78 15.3284 78.6716 16 79.5 16Z",
    stroke: "#52AE30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5 78C83.3284 78 84 77.3284 84 76.5C84 75.6716 83.3284 75 82.5 75C81.6716 75 81 75.6716 81 76.5C81 77.3284 81.6716 78 82.5 78Z",
    fill: "#52AE30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M85 24H88",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92 24H95",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90 26V29",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M90 22V19",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1 77H6",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 77H15",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8 79V84",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8 75V70",
    stroke: "#52AE30",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpCheck);
export default __webpack_public_path__ + "static/media/OTP-check.3178ef1021b8aad6000e4313a24c7426.svg";
export { ForwardRef as ReactComponent };